export class PersonOrganization {
    organizationId:string;
    organization:string;
    orgdesc?:string;
    email?:string;
    im?: string;
    www:string;
    address?:string;
    address2?:string;
    zip?:string;
    city?:string;
    country?:string;
    phone?:string;
    logourl?:string;
    modules:string;
    personId:string;
    membername:string;
    member_function?:string;
    date_joined:string;
    date_left?:string;
    date_created?:string;
    show?:boolean;
    assigned?:boolean;
    projectTemplateRole?:string;
    projectrole?:string;
    username?:string;
    sendinvite?:boolean;
    relationtype?:string;
    triggermade?: any;
    fte?: number;
    isActive?: boolean;
}